import React, { useState } from 'react'
import PropTypes from 'prop-types'
import componentsObj from './dataset'

const ArchiveList = ({
  selectedVenue,
}) => {
  const [selectedComponent, setSelectedComponent] = useState('won-leads')
  const RenderComponent = componentsObj.find(({ value }) => value === selectedComponent).component

  return (
    <div className="pt-8">
      <div className="merchant-archive-nav border-b">
        <ul className="flex">
          {componentsObj.map((component) => {
            return (
              <li
                key={component.value}
                onClick={() => {
                  setSelectedComponent(component.value)
                }}
               className={`px-6 py-3 cursor-pointer font-medium ${
                  component.value === selectedComponent
                    ? 'text-primary-orange border-b-2 border-primary-orange'
                    : ''
                }`}
              >
                {component.title}
              </li>
            )
          })}
        </ul>
      </div>
      <div className="merchant-archive-list">
        <RenderComponent
          selectedVenue={selectedVenue}
        />
      </div>
    </div>
  )
}

ArchiveList.propTypes = {
  selectedVenue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default ArchiveList
